import { createForm, fetchFormById, getImage, updateForm, uploadImage } from ".";

export const handleGetForm = async (formId) => {
    try {
        const {data} = await fetchFormById(formId);
        return data;

    } catch (error) {
        console.log(error);
    }
}

export const handleCreateForm = async (newForm) => {
    try {
        const res = await createForm(newForm);
        return res;
    } catch (error) {
        console.log(error);
    }
}

export const handleUpdateForm = async (formId, updatedForm) => {
    try {
        const res = await updateForm(formId, updatedForm);
        return res;
    } catch (error) {
        console.log(error);
    }
}

export const handleDeleteAttachment = async (formId, attachment) => {
    try {
        const res = await updateForm(formId, attachment);
        return res;
    } catch (error) {
        console.log(error);
    }
}

//attachment
export const getImageUrl = async (url) => {
    try {
        const { data } = await getImage(url);
        return data;
    } catch (error) {
        console.log(error);
    }
}

export const uploadImageToServer = async (image) => {
    try {
        const {data} = await uploadImage(image);
        return data;
    } catch (error) {
        console.log(error);
    }
}